module.exports = __webpack_public_path__ + "static/the-power-of-full-engagement-bfb882794b7c91e5c1ea0b5a2682d44a.jpg";